import React, { useCallback } from 'react';
import cx from 'classnames';

import { useBetHistoryItemState } from '@atlas/core';
import {
  CancelOrderCashoutPopup,
  Icon,
  Label,
  OrderCashoutPopup,
  PartialCashoutPopup,
  Tab,
  TabContent,
  TabNavigator,
} from '@atlas/ui';

import { NotificationEmitterBasePopup } from 'common/Popup/NotificationEmitterBasePopup';

const CashoutPopup = props => {
  const { orderCashoutDisabled, partialCashoutDisabled, setOpenPopup } = props;
  const onClosePopup = useCallback(() => setOpenPopup(false), []);

  const { orderCashOut } = useBetHistoryItemState();

  const orderCashoutAvailable = !orderCashoutDisabled;
  const partialCashoutAvailable = !partialCashoutDisabled;

  const popupClassName = cx('cashout-modal', {
    'auto-cashout': !partialCashoutAvailable,
    'single-cashout': !(orderCashoutAvailable && partialCashoutAvailable),
  });

  return (
    <NotificationEmitterBasePopup className={popupClassName}>
      <TabNavigator index={orderCashoutDisabled ? 1 : 0}>
        <div className="cashout-modal">
          <div className="tabs-list">
            {orderCashoutAvailable && (
              <Tab index={0}>
                <Label message={partialCashoutAvailable ? 'order_cash_out' : 'auto_cash_out'} />
              </Tab>
            )}

            {partialCashoutAvailable && (
              <Tab index={1}>
                <Label message="partial_cash_out" />
              </Tab>
            )}

            <button className="cashout-modal__close" onClick={onClosePopup} type="button">
              <Icon name="close" />
            </button>
          </div>

          {orderCashoutAvailable && (
            <TabContent index={0}>
              {orderCashOut ? (
                <CancelOrderCashoutPopup onClosePopup={onClosePopup} />
              ) : (
                <OrderCashoutPopup
                  onClosePopup={onClosePopup}
                  partialCashoutDisabled={partialCashoutDisabled}
                />
              )}
            </TabContent>
          )}

          {partialCashoutAvailable && (
            <TabContent index={1}>
              <PartialCashoutPopup onClosePopup={onClosePopup} />
            </TabContent>
          )}
        </div>
      </TabNavigator>
    </NotificationEmitterBasePopup>
  );
};

export default CashoutPopup;
